import contatoApi from '../../api/contato'

// initial state
const state = {};

// actions
const actions = {
  enviarFormularioContato({ commit }, payload) {
    return contatoApi.enviarFormularioContato(payload)
      .then(({ data }) => {});
  },
};

const mutations = {};

export default {
  state,
  actions,
  mutations,
};
